export default __webpack_public_path__ + "static/media/gp-1.9c4b9125.png";